export class GetUsersGeoTracksRequest {
    userIds: number[] = [];
    date: Date;
}